import { TWOFACTOR_TYPE } from "./login.interface";

export interface AuthState {
  user: string;
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: string;
  first_login: boolean;
  twofa: {
    preliminaryToken: string | null;
    otpConfig: OTPConfigResponse[];
    isTwoFactorAuthenticationEnabled: boolean;
    isTwoFactorAuthenticated: boolean;
    qrImage: string | null;
    fullHash: string | null;
    chosenMethod: {
      type?: TWOFACTOR_TYPE;
      id?: number;
      newMethod?: boolean;
    } | null;
  };
  authenticated: boolean;
  application_user_id: number;
  loading: boolean;
  error: any;
  ui: UiAuth;
}

export interface UiAuth {
  currentView?: string;
  loadBtn?: boolean;
  loginStage: LOGIN_STAGE;
  openResetPasswordModal: boolean;
}

export interface RetailerInfo {
  retailer_name: string;
  email: string;
  password: string;
}

export type OTPConfigResponse = {
  id: number;
  type: TWOFACTOR_TYPE;
  blurredKey?: string;
  nickname?: string;
};

export enum LOGIN_STAGE {
  LOGIN = "LOGIN",
  PHONE_CONFIG = "PHONE_CONFIG",
  GOOGLE_QR = "GOOGLE_QR",
  TWOFACTOR_PROMPT = "TWOFACTOR_PROMPT",
  GOOGLE_OTP_INPUT = "GOOGLE_OTP_INPUT",
  PHONE_OTP_INPUT = "PHONE_OTP_INPUT",
  GOOGLE_NICKNAME_INPUT = "GOOGLE_NICKNAME_INPUT",
}
